import { setCommonHeaders } from '@/utils/api'

export const signSecretKey = 'x-sign-secret' as const

export function signSecretHeader() {
  const setSignSecretHeader = (secret: string) => {
    setCommonHeaders((headers) => {
      return { ...headers, [signSecretKey]: secret }
    })
  }

  const removeSignSecretHeader = () => {
    setCommonHeaders((headers) => {
      const _headers = { ...headers }
      if (_headers[signSecretKey]) {
        delete _headers[signSecretKey]
      }
      return _headers
    })
  }

  return {
    setSignSecretHeader,
    removeSignSecretHeader,
  }
}
